module.exports = __webpack_public_path__ + "static/media/general.e020f5d7.svg";